"use client";

import React from "react";
import styles from "./call-action.module.css";
import PhoneIcon from "@mui/icons-material/Phone";
import Image from "next/image";
import Link from "next/link";

export interface VariantProps {
  zalo?: [
    {
      url: string;
      label: string;
      target: string;
      rel?: string;
    },
  ];
  phone?: [
    {
      url: string;
      label: string;
      target: string;
      rel?: string;
    },
  ];
}
const CallNowDefault: React.FC<VariantProps> = ({ zalo, phone }) => {
  return (
    <div className={styles.callActionContainer}>
      {zalo && zalo.length
        ? zalo.map((z, i) => {
            return (
              <button key={`${z.url}_${i}`} className={styles.callActionButtonZalo}>
                <Link rel={z.rel || "nofollow noreferrer"} href={z.url || ""} target={z.target}>
                  <Image
                    src="/assets/images/vendor/zalo.svg"
                    alt={z.label}
                    width="26"
                    height="24"
                  />
                </Link>
              </button>
            );
          })
        : null}
      {phone && phone.length
        ? phone.map((p, i) => {
            return (
              <div key={`${p.url}_${i}`} className={styles.callActionButtonPhone}>
                <a
                  rel={p.rel || "nofollow noreferrer"}
                  href={p.url || ""}
                  target={p.target}
                  className={styles.callActionPhoneLink}
                >
                  <span className={styles.callActionSrOnly}>{p.label || "Gọi điện"}</span>
                  <PhoneIcon aria-hidden />
                </a>
              </div>
            );
          })
        : null}
    </div>
  );
};

CallNowDefault.displayName = "CallNowDefault";

export default CallNowDefault;
